var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 29,
    viewBox: "0 0 40 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 11.8647C33.815 11.8631 36.78 13.3278 38.6667 15.8191",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33331 15.8191C3.21998 13.3278 6.18498 11.8631 9.33331 11.8647",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.4096C23.6819 22.4096 26.6666 19.4589 26.6666 15.8191C26.6666 12.1792 23.6819 9.22852 20 9.22852C16.3181 9.22852 13.3333 12.1792 13.3333 15.8191C13.3333 19.4589 16.3181 22.4096 20 22.4096Z",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 27.6818C13.705 22.5856 20.345 20.8886 25.5 23.8922C27.0817 24.8132 28.4017 26.1182 29.3334 27.6818",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 5.27393C26.2367 2.45482 29.145 0.759409 31.9967 1.48766C34.8483 2.21592 36.5633 5.09104 35.8267 7.91014C35.2183 10.2366 33.0967 11.8628 30.665 11.8645",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33336 11.8647C6.38836 11.8647 4.00169 9.50197 4.00336 6.58896C4.00336 3.67759 6.39336 1.31818 9.34002 1.31983C11.7717 1.31983 13.8934 2.94769 14.5017 5.27415",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyIcon1);
export default __webpack_public_path__ + "static/media/why_icon1.7bef407f04bcf2c5ecf93d17c9d0d9c2.svg";
export { ForwardRef as ReactComponent };